import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import { Button } from '../ui/Button'
import { Container } from '../ui/Container'
import { Menu, X, Search } from 'lucide-react'

const navigation = [
  { name: 'Toko Buku', href: '/shop' },
  { name: 'Penerbitan', href: '/penerbitan' },
  { name: 'Konversi KTI', href: '/konversi-kti' },
  { name: 'Jasa Cetak', href: '/jasa-cetak' },
  { name: 'Pra Cetak', href: '/pra-cetak' },
]

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/80 border-b border-brand-slate-200/60">
      <Container>
        <nav className="flex items-center justify-between h-14 sm:h-16 gap-4 sm:gap-6">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group">
            <img src="/logo.png" alt="logo pranala" className='h-44 w-44 object-contain' loading="eager" decoding="async" width={176} height={176}/>
          </Link>

          {/* Search - Desktop */}
          <div className="hidden lg:flex flex-1 max-w-md relative group">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-brand-slate-400 group-focus-within:text-brand-yellow-500 transition-colors">
              <Search className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <input
              type="text"
              className="block w-full pl-10 pr-3 py-2 border border-brand-slate-200 rounded-lg leading-5 bg-brand-slate-50 text-brand-slate-800 placeholder-brand-slate-400 focus:outline-none focus:bg-white focus:ring-1 focus:ring-brand-yellow-400 focus:border-brand-yellow-400 text-sm transition-all shadow-sm"
              placeholder="Cari judul buku, penulis..."
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:gap-6">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm text-brand-slate-600 hover:text-brand-yellow-600 font-medium transition-colors duration-200 font-sans"
              >
                {item.name}
              </a>
            ))}
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4">

            <Button
              asChild
              className="hidden sm:inline-flex bg-brand-yellow-400 hover:bg-brand-yellow-500 text-brand-slate-900 font-medium rounded-lg text-xs sm:text-sm border-0 shadow-sm hover:shadow-md transition-all px-3 sm:px-4"
            >
              <a href="/kontak">Hubungi Kami</a>
            </Button>

            {/* Mobile menu button */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-brand-slate-500 hover:text-brand-slate-800 h-8 w-8 sm:h-10 sm:w-10"
            >
              {mobileMenuOpen ? (
                <X className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={1.5} />
              ) : (
                <Menu className="h-5 w-5 sm:h-6 sm:w-6" strokeWidth={1.5} />
              )}
            </Button>
          </div>
        </nav>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-brand-slate-200 py-3 sm:py-4">
            {/* Mobile Search */}
            <div className="relative mb-3 sm:mb-4">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-brand-slate-400">
                <Search className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} />
              </div>
              <input
                type="text"
                className="block w-full pl-9 sm:pl-10 pr-3 py-2 border border-brand-slate-200 rounded-lg bg-brand-slate-50 text-brand-slate-800 placeholder-brand-slate-400 focus:outline-none focus:ring-1 focus:ring-brand-yellow-400 focus:border-brand-yellow-400 text-sm"
                placeholder="Cari buku..."
              />
            </div>

            <div className="space-y-1">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block px-3 py-2 text-sm sm:text-base font-medium text-brand-slate-700 hover:text-brand-yellow-600 hover:bg-brand-slate-50 rounded-lg transition-colors duration-200 font-sans"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </a>
              ))}
              <div className="pt-3 sm:pt-4 border-t border-brand-slate-200 mt-3 sm:mt-4 space-y-3">
                <Button
                  asChild
                  className="w-full bg-brand-yellow-400 hover:bg-brand-yellow-500 text-brand-slate-900 font-medium rounded-lg text-sm border-0 shadow-sm"
                >
                  <a href="/kontak">Hubungi Kami</a>
                </Button>
              </div>
            </div>
          </div>
        )}
      </Container>
    </header>
  )
}
